const RestaurantsData = {
    "Bon Bon's Coffee": {
      title: "Bon Bon's Coffee",
      minimumOrder: 5,
      deliveryTime: "15-20",
      rating: 4.8,
      reviews: "1,500",
      operatingHours: "9:00 PM",
      link: "/restaurants/bon-bons-coffee",
      image: "bonbons.png",
    },
    "Don's at Walb": {
      title: "Don's at Walb",
      minimumOrder: 10,
      deliveryTime: "20-25",
      rating: 4.5,
      reviews: "2,000",
      operatingHours: "8:00 PM",
      link: "/restaurants/dons-at-walb",
      image: "donsatwalb.jpg",
    },
    "Einstein Bros.": {
      title: "Einstein Bros. Bagels",
      minimumOrder: 8,
      deliveryTime: "10-15",
      rating: 4.7,
      reviews: "1,800",
      operatingHours: "10:00 PM",
      link: "/restaurants/einstein-bros-bagels",
      image: "einstienbros.png",
    },
    "Java Spot": {
      title: "Java Spot",
      minimumOrder: 7,
      deliveryTime: "10-20",
      rating: 4.6,
      reviews: "200",
      operatingHours: "11:00 PM",
      link: "/restaurants/java-spot",
      image: "starbucks.png",
    },
  };
  
  export default RestaurantsData;
  